import React from "react";

export default function BgBlurLoader() {
  return (
    <div className="loader bg-blur">
      <figure className="iconLoaderProgress">
        <svg className="iconLoaderProgressFirst" width="240" height="240">
          <circle cx="120" cy="120" r="100"></circle>
        </svg>

        <svg className="iconLoaderProgressSecond" width="240" height="240">
          <circle cx="120" cy="120" r="100"></circle>
        </svg>
      </figure>
    </div>
  );
}
